import { render, staticRenderFns } from "./DeleteConfirmIcon.vue?vue&type=template&id=e830a492"
import script from "./DeleteConfirmIcon.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports